import {ReceiptLayout} from '../ReceiptLayouts/Model'
import BusinessUnit from '../BusinessUnits/Model'
import {Tax} from '../Taxes/Model'

export default class OperationLine {
  id: number
  name: string
  description?: string
  code?: string
  emailNotification?: string
  emailAlert?: string
  // tslint:disable-next-line:variable-name
  receiptLayout_id?: ReceiptLayout
  // tslint:disable-next-line:variable-name
  businessUnit_id: string
  businessUnit: BusinessUnit
  capacity?: number
  // tslint:disable-next-line:variable-name
  tax_id?: Tax

  constructor(props: OperationLine) {
    Object.assign(this, props)
    if (props.businessUnit) {
      this.businessUnit = new BusinessUnit(props.businessUnit)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/OperationLines/Model.ts